import { authenticated } from '../../helpers/auth-header';
import insighttAPI from '../clients/insightt-api-client';
import { commissionsEndpoints } from '../endpoints';

const getCustomCommissions = () => authenticated(insighttAPI).get(commissionsEndpoints.getCustomCommissionsAPI());

const submitCustomCommission = (payload) =>
  authenticated(insighttAPI).post(commissionsEndpoints.submitCustomCommissionAPI(), payload);

const updateCustomCommission = (commissionId, payload) =>
  authenticated(insighttAPI).put(commissionsEndpoints.updateCustomCommissionAPI(commissionId), payload);

const cancelCustomCommission = (commissionId) =>
  authenticated(insighttAPI).delete(commissionsEndpoints.cancelCustomCommissionAPI(commissionId), {});

const approveCustomCommission = (commissionId) =>
  authenticated(insighttAPI).put(commissionsEndpoints.approveCustomCommissionAPI(commissionId), {});

const declineCustomCommission = (commissionId) =>
  authenticated(insighttAPI).put(commissionsEndpoints.declineCustomCommissionAPI(commissionId), {});

export const commissionsService = {
  getCustomCommissions,
  submitCustomCommission,
  updateCustomCommission,
  cancelCustomCommission,
  approveCustomCommission,
  declineCustomCommission,
};
